/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { TrainingJobFragmentDoc, TrainingJobForLogsAndMetricsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrainingJobQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type TrainingJobQuery = { __typename?: 'QueryPrediction', trainingJob: { __typename?: 'TrainingJob', id: string, name: string, created: any, modified: any, elapsedTimeSeconds: number, instanceType: { __typename?: 'InstanceType', name: string, gpuCount: number, gpuType: Types.GpuType | null | undefined }, status: { __typename?: 'TrainingJobStatusType', value: Types.TrainingJobStatus, created: any }, project: { __typename?: 'TrainingProject', name: string } } | null | undefined };

export type TrainingJobForLogsAndMetricsQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type TrainingJobForLogsAndMetricsQuery = { __typename?: 'QueryPrediction', trainingJob: { __typename?: 'TrainingJob', id: string, created: any, elapsedTimeSeconds: number, instanceType: { __typename?: 'InstanceType', name: string, nodeCount: number | null | undefined, gpuCount: number } } | null | undefined };


export const TrainingJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainingJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingJob"},"name":{"kind":"Name","value":"training_job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"training_job_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingJobFragment"}}]}}]}},...TrainingJobFragmentDoc.definitions]} as unknown as DocumentNode<TrainingJobQuery, TrainingJobQueryVariables>;
export const TrainingJobForLogsAndMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainingJobForLogsAndMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingJob"},"name":{"kind":"Name","value":"training_job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"training_job_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingJobForLogsAndMetricsFragment"}}]}}]}},...TrainingJobForLogsAndMetricsFragmentDoc.definitions]} as unknown as DocumentNode<TrainingJobForLogsAndMetricsQuery, TrainingJobForLogsAndMetricsQueryVariables>;
export const namedOperations = {
  Query: {
    TrainingJob: 'TrainingJob',
    TrainingJobForLogsAndMetrics: 'TrainingJobForLogsAndMetrics'
  }
}

/**
 * __useTrainingJobQuery__
 *
 * To run a query within a React component, call `useTrainingJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainingJobQuery(baseOptions: Apollo.QueryHookOptions<TrainingJobQuery, TrainingJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingJobQuery, TrainingJobQueryVariables>(TrainingJobDocument, options);
      }
export function useTrainingJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingJobQuery, TrainingJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingJobQuery, TrainingJobQueryVariables>(TrainingJobDocument, options);
        }
export type TrainingJobQueryHookResult = ReturnType<typeof useTrainingJobQuery>;
export type TrainingJobLazyQueryHookResult = ReturnType<typeof useTrainingJobLazyQuery>;
export type TrainingJobQueryResult = Apollo.QueryResult<TrainingJobQuery, TrainingJobQueryVariables>;
export function refetchTrainingJobQuery(variables: TrainingJobQueryVariables) {
      return { query: TrainingJobDocument, variables: variables }
    }
/**
 * __useTrainingJobForLogsAndMetricsQuery__
 *
 * To run a query within a React component, call `useTrainingJobForLogsAndMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingJobForLogsAndMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingJobForLogsAndMetricsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainingJobForLogsAndMetricsQuery(baseOptions: Apollo.QueryHookOptions<TrainingJobForLogsAndMetricsQuery, TrainingJobForLogsAndMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingJobForLogsAndMetricsQuery, TrainingJobForLogsAndMetricsQueryVariables>(TrainingJobForLogsAndMetricsDocument, options);
      }
export function useTrainingJobForLogsAndMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingJobForLogsAndMetricsQuery, TrainingJobForLogsAndMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingJobForLogsAndMetricsQuery, TrainingJobForLogsAndMetricsQueryVariables>(TrainingJobForLogsAndMetricsDocument, options);
        }
export type TrainingJobForLogsAndMetricsQueryHookResult = ReturnType<typeof useTrainingJobForLogsAndMetricsQuery>;
export type TrainingJobForLogsAndMetricsLazyQueryHookResult = ReturnType<typeof useTrainingJobForLogsAndMetricsLazyQuery>;
export type TrainingJobForLogsAndMetricsQueryResult = Apollo.QueryResult<TrainingJobForLogsAndMetricsQuery, TrainingJobForLogsAndMetricsQueryVariables>;
export function refetchTrainingJobForLogsAndMetricsQuery(variables: TrainingJobForLogsAndMetricsQueryVariables) {
      return { query: TrainingJobForLogsAndMetricsDocument, variables: variables }
    }